var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "9 0 512 512",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fb8c00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Groupx3E__28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376 60v60h-240v-60h-75v452h390v-452zm-225 397.21-40.61-40.6 21.22-21.22 19.39 19.4 49.39-49.4 21.22 21.22zm0-90-40.61-40.6 21.22-21.22 19.39 19.4 49.39-49.4 21.22 21.22zm0-90-40.61-40.6 21.22-21.22 19.39 19.4 49.39-49.4 21.22 21.22zm240 143.79h-150v-30h150zm0-90h-150v-30h150zm0-90h-150v-30h150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 30c0-16.569-13.43-30-30-30-16.569 0-30 13.43-30 30-7.259 0-52.693 0-60 0v60h180c0-7.259 0-52.693 0-60-7.259 0-52.693 0-60 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.db38ee66dc9d7f2e70bd0edc259af1a9.svg";
export { ForwardRef as ReactComponent };